import { render } from "./Cuotas.vue?vue&type=template&id=6efd663a"
import script from "./Cuotas.vue?vue&type=script&lang=ts"
export * from "./Cuotas.vue?vue&type=script&lang=ts"
script.render = render

export default script